import React, { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient'; 
import CLIENT_BG from '../assets/anothereclass/image00013.jpeg'; 

const Clients = () => {
  const [clientLogos, setClientLogos] = useState([]);
  const [loading, setLoading] = useState(true);

  
const fetchClients = async () => {
  try {
    setLoading(true);
    const { data, error } = await supabase
      .from('clients') 
      .select('*')
      // 'order_index' ko badal kar 'display_order' karein
      .order('display_order', { ascending: true }); 

    if (error) {
      console.error('Supabase Error:', error.message);
    } else {
      setClientLogos(data || []);
    }
  } catch (err) {
    console.error('Fetch Error:', err);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    fetchClients();
  }, []);

  return (
    <section id="clients" className="bg-white pt-0 overflow-hidden">
      {/* Hero Section with Background */}
      <div 
     className="relative text-center flex items-center justify-center h-[60vh] md:h-[95vh] bg-cover bg-center overflow-hidden" 
        style={{ backgroundImage: `url(${CLIENT_BG})` }}
      >
         <div className="absolute inset-0 bg-gradient-to-b from-[#0a1128]/90 via-[#0a1128]/80 to-[#0a1128]/95 z-0"></div>
      
          
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-5xl md:text-7xl font-black mb-4 uppercase tracking-tighter text-white drop-shadow-xl">
            Our <span className="text-blue-400">Trusted Clientele</span>
          </h2>
          <p className="max-w-3xl mx-auto text-white text-xl md:text-2xl leading-relaxed font-bold italic drop-shadow-2xl mt-4">
  A Quarter Century of Reliable Partnerships and Premium Service.
</p>
        </div>
      </div>

      {/* Logos Grid Section */}
      <div className="container mx-auto px-4 md:px-12 py-20">
        {loading ? (
          <div className="flex justify-center items-center h-40">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
            <span className="ml-3 text-slate-600 font-medium">Loading amazing clients...</span>
          </div>
        ) : clientLogos.length > 0 ? (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {clientLogos.map((client, index) => (
              <div 
                key={client.id || index} 
                className="bg-white p-6 rounded-none border border-slate-100 shadow-sm flex items-center justify-center h-40 transition-transform hover:scale-105 hover:shadow-md"
              >
                <img 
                  src={client.logo_url} 
                  alt={client.name || 'Client Logo'} 
                  className="max-h-full max-w-full object-contain" 
                  loading="lazy"
                  onError={(e) => {
                    e.target.src = 'https://via.placeholder.com/150?text=Logo+Missing'; 
                  }}
                />
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center text-slate-500 py-10">
            No clients found in the database.
          </div>
        )}
      </div>
    </section>
  );
};

export default Clients;